import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

class OperationHoursForm extends Component {

  render() {
    let {errors, handleSubmit, submit, timezones, times, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Timezone"
              name="timezone"
              component={DropDownInputField}
              data={timezones}
              valueKey="value"  
              titleKey="value" 
              showBlank={true}
              serverError={this.props.errors.timezone}
              />
            <Field 
              label="Opening Time"
              name="openingTime"
              component={DropDownInputField}
              data={times}
              valueKey="value"  
              titleKey="title" 
              showBlank={true}
              serverError={this.props.errors.openingTime}
              />
            <Field 
              label="Closing Time"
              name="closingTime"
              component={DropDownInputField}
              data={times}
              valueKey="value"  
              titleKey="title" 
              showBlank={true}
              serverError={this.props.errors.closingTime}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "OperationHoursForm"
})(OperationHoursForm);

export default ReduxForm;